module.exports = __webpack_public_path__ + "static/media/S1N3-1.80ed19f4.svg";